<div class="bread-crumb-comp">
  @if (showBreadCrumbs) {
    <div class="bread-crumb-wrapper">
      <nav aria-label="breadcrumb" class="bread-crumb-nav-container">
        @if (breadcrumbs?.length) {
          @for (item of breadcrumbs; track $index) {
            @if (!item.isLast) {
              <a class="bread-crumb-link" [routerLink]="item.PATH">{{ item.PAGE }}</a>
              <span><nuc-icon iconClass="chevron_right" size="20"></nuc-icon></span>
            } @else {
              <span class="bread-crumb-page-name">{{ item.PAGE }}</span>
            }
          }
        }
      </nav>
    </div>
  }
</div>
